import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';

export const SEND_ACTIVATION_LINK = gql`
  mutation SendActivationLink($input: SendActivationLinkInput!) {
    sendActivationLink(input: $input)
  }
`;

export const useSendActivationLinkMutation = () => {
  const [
    sendActivationLink,
    {
      loading: sendActivationLinkLoading,
      error: sendActivationLinkError,
      data: isActivationLinkSend,
    },
  ] = useMutation(SEND_ACTIVATION_LINK);

  return {
    sendActivationLink,
    sendActivationLinkLoading,
    sendActivationLinkError,
    isActivationLinkSend,
  };
};
